import createOrUpdateHiddenField from './createOrUpdateHiddenField';
import getKeysForExtraInfo from './getKeysForExtraInfo';

/**
 *
 * @param {Object} win
 * @param {HTMLFormElement} form
 * @param {Object} prefParams
 */
const injectExtraInfo = (
	win,
	form,
	{ cookiesForExtraInfo = '', paramsForExtraInfo = '' } = {}
) => {
	const cookieNames = getKeysForExtraInfo(win, cookiesForExtraInfo);
	const paramNames = getKeysForExtraInfo(win, paramsForExtraInfo);

	cookieNames.forEach((mappedCookieName, cookieName) => {
		const cookieValue = win.Cookies.get(cookieName);

		// We inject the cookie if it exists
		if (cookieValue) {
			createOrUpdateHiddenField(
				form,
				`_custom=${mappedCookieName.toUpperCase()}=1=${mappedCookieName}`,
				cookieValue
			);
		}
	});
	paramNames.forEach((param) => {
		const paramValue = win.sessionStorage.getItem(
			`extra-info-param-${param}`
		);

		// We inject the param if it exists
		if (paramValue) {
			createOrUpdateHiddenField(
				form,
				`_custom=${param.toUpperCase()}=1=${param}`,
				paramValue
			);
		}
	});
};
export default injectExtraInfo;
